import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const [openDropdown, setOpenDropdown] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };
    const { t } = useTranslation();
    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-8">
                    <div style={{ paddingLeft: "10%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{ display: 'flex' }}>
                            <div className="logo-image" >
                                <img src="./images/pattarath-logo.png" style={{ width: "100%" }} alt="logo" />
                            </div>
                            <div style={{ float: 'left', display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'center', }}>
                                <span className="templename">
                                    {t("Temple_name")}
                                </span>
                                {/* <span className="templename">
                                   പട്ടാരത്ത് ശ്രീ ചാമുണ്ഡേശ്വരി ക്ഷേത്രം 
                                </span> */}
                            </div>

                        </div>



                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                    <LanguageSelector />
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                {t("Home")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                                {t("History")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.pattarathtemple.org/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                {t("Online Bookiing")}
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                                {t("Darsan Time")}
                            </Link>
                        </div>

                        {/* <div className="boxes">
                            <Link to="/Administration" className="menuitems" onClick={closeMenu}>
                                {t("Administration")}
                            </Link>
                        </div> */}

                        <div className="boxes">
                            <Link to="/Gallery" className="menuitems" onClick={closeMenu}>
                                {t("Gallery")}
                            </Link>
                        </div>

                        {/* <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                                {t("Contact")}
                            </Link>
                        </div> */}


                        <div className="boxes dropdown">
                            <span
                                className="menuitems more-btn"
                                onClick={() => setOpenDropdown(!openDropdown)}
                            >
                                {t("More")}
                            </span>

                            <div className={`dropdown-content ${openDropdown ? "show" : ""}`}>
                                <Link to="/Administration" className="dropdown-item" onClick={closeMenu}>
                                    {t("Administration")}
                                </Link>
                                <Link to="/Contact" className="dropdown-item" onClick={closeMenu}>
                                    {t("Contact")}
                                </Link>
                            </div>
                        </div>
                        <div className="boxes">
                            <LanguageSelector />
                        </div>

                    </div>
                </div>
            </div>
            <div style={{ width: '100px', height: '100px', position: 'fixed', bottom: '0', left: '0', marginLeft: '20px', marginBottom: '20px' }}>
                <a href="https://booking.pattarathtemple.org/"> <img src="./images/online-booking.png" alt="Online Booking" style={{ width: '100%', border: '4px solid white', borderRadius: '10px' }} /></a>
                {/* <a href="https://booking.pattarathtemple.org/"> <img src="./images/online-booking.png" alt="Online Booking" style={{ width: '100%', border: '4px solid white', borderRadius: '10px' }} /></a> */}
            </div>
        </div>
    );
}

export default MainMenu;
